<template>
  <BaseModal class="create-web-customer-modal" v-model="isOpenModal">
    <template v-slot:header>
      Create Web Customer
    </template>
    <div class="body p-6 pt-2">
      <CreateWebCustomerForm
        :infoautoId="infoautoId"
        submitLabel="Create Customer"
        @customerCreated="onCreated"
      />
    </div>
  </BaseModal>
</template>

<script>
import CreateWebCustomerForm from "@/components/customer/CreateWebCustomerForm.vue";

export default {
  name: "CreateWebCustomerModal",
  components: { CreateWebCustomerForm },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    infoautoId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isOpenModal: this.value
    };
  },
  watch: {
    value(val) {
      this.isOpenModal = val;
    },
    isOpenModal(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    onCreated(customer) {
      this.$emit("customerCreated", customer);
      this.isOpenModal = false;
    }
  }
};
</script>
